import * as Yup from 'yup';

const createPortfolioSchema = Yup.object().shape({
  dossierName: Yup.string()
    .max(150)
    .required(),
});

export { createPortfolioSchema };
